import { render, staticRenderFns } from "./FormDropdown.vue?vue&type=template&id=3ed0705a&"
import script from "./FormDropdown.vue?vue&type=script&lang=ts&"
export * from "./FormDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports